module.exports = __webpack_public_path__ + "img/ico3.2df658ff.png";